export function changeSalesPriceBasis(row, select, weightSelector) {
    const previous = select.dataset.previousBasis || select.value
    const quantity = Number(row.querySelector("input[name$='[quantity]']")?.value || 0)
    const kg = Number(row.querySelector(weightSelector)?.value || 0)
    const perUnit = quantity > 0 ? kg / quantity : 0
    const price = row.querySelector("input[name$='[unit_price]']")
    if (previous !== select.value && perUnit > 0 && price) {
        const amount = Number(price.value || 0)
        price.value = (previous === "weight" ? amount * perUnit : amount / perUnit).toFixed(4)
    }
    select.dataset.previousBasis = select.value
}
